var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraDarkColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.695,
    height: 17.362,
    viewBox: "0 0 21.695 17.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.78,110.376h-8.52a2.18,2.18,0,0,1-2.329-2.33V98.238a2.179,2.179,0,0,1,2.33-2.328H31.3a2.178,2.178,0,0,1,2.329,2.33v9.9A2.15,2.15,0,0,1,32.01,110.3a2.769,2.769,0,0,1-.693.079Q27.047,110.381,22.78,110.376Zm5.061-7.236a5.061,5.061,0,1,0-5.055,5.067,5.061,5.061,0,0,0,5.055-5.067ZM16.272,99.525a.723.723,0,1,0-.715.723.723.723,0,0,0,.715-.723Z",
    transform: "translate(-11.93 -93.017)",
    fill: "#1f2e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.57,50.049c.151-.583.278-1.156.45-1.714a.635.635,0,0,1,.648-.442q2.9-.007,5.805,0a.623.623,0,0,1,.637.422c.176.565.308,1.145.462,1.733Z",
    transform: "translate(-118.723 -47.89)",
    fill: "#1f2e3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.23,159.561a3.615,3.615,0,1,1-3.6-3.622A3.615,3.615,0,0,1,139.23,159.561Zm-3.519-2.9a.727.727,0,1,0-.051,1.446,1.448,1.448,0,0,1,1.4,1.411.725.725,0,1,0,1.447-.033A2.9,2.9,0,0,0,135.711,156.666Z",
    transform: "translate(-124.766 -149.429)",
    fill: "#1f2e3d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraDarkColor);
export default __webpack_public_path__ + "static/media/camera-dark-color.c0f5b97d66923f3f3a5f982e10e11844.svg";
export { ForwardRef as ReactComponent };